module.exports = __webpack_public_path__ + "static/media/jack-cox-2.de812fe4.jpg";